module.exports = __webpack_public_path__ + "img/icon-subgroups.48c6ebe5.svg";